import React, { Component } from 'react'
import './index.less'
import {
  setDocumentTitle,
  setUidToken,
  getlang,
  setlang,
  unix2date6,
  inject,
  observer
} from '../../../helper/devTools.js'
import Message from '../../../component/Message'
/* import config from 'src/core/config'
import vs from '../../../helper/vconsole' */
@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
    this.ludoStore = this.props.store.register('ludo/main')
    setDocumentTitle(`History`)
  }
  state = {
    lang: {},
    recordList: [],
    hasMore: false,
    scrollParams: "0,30",
    messageTxt: "",
    type:1,
    language:'en'
  }

  async initLang() {
    let { language } = this.props.location.query
    language =await getlang(language)
    this.setState({
      lang: setlang(language, this.ludoStore.data.lang),
      language: language,
    })
  }

  async initUid() {
    let uid = await setUidToken(this.props.location.query)
    console.log(uid, 'uid')
    return uid
  }

  async getList() {
    let {type} = this.state
    let recordList = await this.ludoStore.apiGetLudoRecord(this.state.scrollParams,type)
    console.log(recordList)
    this.setState({
      recordList: recordList && recordList.res && recordList.res.list,
      hasMore: recordList && recordList.res && recordList.res.hasMore,
      scrollParams: recordList && recordList.res && recordList.res.scroll,
    })
  }

  async getMoreList() {
    let {type} = this.state
    let recordList = await this.ludoStore.apiGetLudoRecord(this.state.scrollParams,type)
    let list = this.state.recordList
    recordList && recordList.res && recordList.res.list.map((i) => {
      list.push(i)
    })
    this.setState({
      recordList: list,
      hasMore: recordList && recordList.res && recordList.res.hasMore,
      scrollParams: recordList && recordList.res && recordList.res.scroll,
    })
  }

  async componentDidMount() {

    try {
      let url = window.location.href.split('?')[1]
      let arr =  url.split('=')
      arr && arr[1] && await this.setState({type:arr[1]*1 })
    } catch (error) {
      
    }
    this.initLang()
    let uid = await this.initUid()
    this.getList()
    await this.RunOnStart(uid)
  }

  // 初始化/接口请求初始化
  RunOnStart = async (uid) => {
    // try {
    //   this.setState({
    //     uid: uid
    //   })
    //   let getUserInfo = await this.ludoStore.GetUserInfoWeb(uid)
    //   if (getUserInfo && getUserInfo.code == 0) {
    //     this.setState({
    //       userInfo: getUserInfo.res
    //     })
    //   }
    // } catch (error) {
    //   console.error(error)
    //   this.refs.msg.show("error")
    // }
  }


  render() {
    let { type } = this.state
    return (
      <div className={`ludo-history-container`}>
        <Message ref="msg" />
        <div className="big-bg"></div>
        {type == 1 && <div className="banner luodou-img"></div>}
        {type == 2 && <div className="banner uno-img"></div>}
        {type == 3 && <div className="banner domino-img"></div>}
        {type == 4 && <div className="banner ok-img"></div>}
        <div className="content">
          <div className="title-items">
            <div>
              {this.state.lang.join}
            </div>
            <div>
              {this.state.lang.income}
            </div>
            <div className='date'>
              {this.state.lang.date}
            </div>
          </div>
          {
            this.state.recordList && this.state.recordList.length > 0 && (
              <div className="his-items">
                {
                  this.state.recordList && this.state.recordList.map((i, k) => {
                    return (
                      <div className="item" key={k}>
                        <div className="join">{i.bet}</div>
                        <div className="income">{i.win}</div>
                        <div className="date">{unix2date6(i.ts)}</div>
                      </div>
                    )
                  })
                }
                {
                  this.state.hasMore && (
                    <div className="more" onClick={() => { this.getMoreList() }}>查看更多</div>
                  )
                }
              </div>
            )
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/ludo/ludohistory/index.js